import React from "react";

import { Button, Container, ListGroup, Row } from "react-bootstrap";
import { IoIosMenu } from "react-icons/io";
import '../assets/css/style.css';

import { TfiMenu } from "react-icons/tfi";
import { IoLogOut, IoWallet } from "react-icons/io5";
import { GiWallet } from "react-icons/gi";
import { FaHistory } from "react-icons/fa";
import { useNavigate, Link } from 'react-router-dom';
import Dashboard from "./Dashboard/Dashboard";
import { MdOutlineHelp } from "react-icons/md";
import { MdDashboard } from "react-icons/md";

// import profile from '../assets/image/bg.png'




const Header = () => {



  const navigate = useNavigate()

  const logout = () => {

    localStorage.removeItem('accessToken');
    navigate('/');
  };




  return (
    <>
      <header className="main-header px5 container-fluid bg-dark">
        <Row className="justify-content-between align-items-center">
          <div className="w-auto">
            <Button className="menu-hb"
              data-bs-toggle="offcanvas"
              data-bs-target="#rightSideMenu">
              <TfiMenu />
            </Button>
          </div>
          <div className="w-auto">
            <h3 onClick={() => navigate("/admin")}>Admin Panel</h3>
          </div>
          <div className="w-auto">
            <img
              src="/img/bg.png"
              alt="profile"
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%"
              }}
            />
          </div>
        </Row>
      </header>

      {/* Sidebar Menu */}
      <div className="offcanvas offcanvas-start hacker-sidebar"
        tabIndex="-1"
        id="rightSideMenu"
        aria-labelledby="offcanvasExampleLabel">

        <div className="offcanvas-header">
          <h4 className="sidebar-title">⚡ Menu Panel</h4>
          <button type="button" className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close">X
          </button>
        </div>

        <div className="offcanvas-body">
          <ul className="hacker-nav">
            <li onClick={() => navigate("/admin")} data-bs-dismiss="offcanvas">
              <MdDashboard /> <span>Dashboard</span>
            </li>
            <li onClick={() => navigate("/deposit")} data-bs-dismiss="offcanvas">
              <IoWallet /> <span>Deposit</span>
            </li>
            <li onClick={() => navigate("/withdraw")} data-bs-dismiss="offcanvas">
              <GiWallet /> <span>Withdrawal</span>
            </li>
            <li data-bs-dismiss="offcanvas">
              <FaHistory /> <span>Game Transition</span>
            </li>
            <li onClick={() => navigate("/help")} data-bs-dismiss="offcanvas">
              <MdOutlineHelp /> <span>Help & Support</span>
            </li>
            <li onClick={logout} data-bs-dismiss="offcanvas">
              <IoLogOut /> <span>Logout</span>
            </li>
          </ul>
        </div>
      </div>
    </>
  );


}

export default Header;